import { useQuery, UseQueryOptions } from "react-query";

import { useChatApi } from "./useChatApi";

export function useChatValidateToken(
  accessToken: string | undefined,
  options?: UseQueryOptions<number | null>
) {
  const api = useChatApi();
  return useQuery({
    queryKey: ["chat-token-validation", accessToken],
    queryFn: async () => {
      if (!accessToken) {
        return null;
      }
      const { data } = await api.getTokenValidation(accessToken);
      return data;
    },
    ...options,
  });
}
